module.exports = __webpack_public_path__ + "img/guide-du-routard.png";